import {createCallable} from './createCallable';

export const jobStart = createCallable('jobStart');
export const jobResume = createCallable('jobResume');
export const jobComplete = createCallable('jobComplete');
export const jobFail = createCallable('jobFail');
export const jobCancel = createCallable('jobCancel');
export const jobDelete = createCallable('jobDelete');
export const jobUpdateStatus = createCallable('jobUpdateStatus');
export const jobUpdateProgress = createCallable('jobUpdateProgress');
export const jobIncreaseRunLimit = createCallable('jobIncreaseRunLimit');
export const jobCleanupOld = createCallable('jobCleanupOld');
